const TEAL = "#006d67";
const GOLD = "#a98445";

function strokeColor(variant, part) {
  if (variant === "white") return "#ffffff";
  if (variant === "monochrome") return TEAL;
  return part === "accent" ? GOLD : TEAL;
}

/**
 * CRA adapter — inline SVG paths synced with packages/design-system/shell/YimnakBrandMark.jsx
 */
export default function YimnakBrandMark({
  variant = "default",
  size = 24,
  className = "",
  label = "Yimnak",
  decorative = false,
  style,
}) {
  const height = Math.round(size * (52 / 48));
  const body = strokeColor(variant, "body");
  const accent = strokeColor(variant, "accent");

  return (
    <span
      className={`dimoy-brand-mark ${className}`.trim()}
      style={{ ...style, width: size, height, "--dimoy-brand-mark-size": `${size}px` }}
      aria-hidden={decorative ? true : undefined}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 52"
        width={size}
        height={height}
        fill="none"
        role={decorative ? undefined : "img"}
        aria-label={decorative ? undefined : label}
        focusable="false"
      >
        <path
          d="M 36 8 C 20 6, 8 18, 8 30 C 8 38, 14 44, 22 44"
          stroke={body}
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M 22 26 L 26 32 L 36 18"
          stroke={accent}
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle cx="20" cy="49" r="3.2" fill={body} />
        <circle cx="30" cy="49" r="3.2" fill={body} />
      </svg>
    </span>
  );
}
